import { Link } from 'react-router-dom';

export default function ArticleFooter() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70 py-10 px-6 md:px-10 mt-16">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <Link to="/" className="text-foreground-700 text-sm hover:text-primary-500 transition-colors border-b border-foreground-300 pb-0.5">
            &larr; Back to GTBuy Spreadsheet Hub
          </Link>
          <div className="flex items-center gap-6">
            <Link to="/what-is-gtbuy-spreadsheet" className="text-foreground-500 text-sm hover:text-foreground-700 transition-colors">
              What is GTBuy
            </Link>
            <Link to="/spreadsheet-comparison" className="text-foreground-500 text-sm hover:text-foreground-700 transition-colors">
              Comparison
            </Link>
            <Link to="/spreadsheet-safety" className="text-foreground-500 text-sm hover:text-foreground-700 transition-colors">
              Safety Guide
            </Link>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="text-foreground-500 text-sm hover:text-foreground-700 transition-colors"
            >
              kaspreadsheet.com
            </a>
          </div>
        </div>
        <p className="text-center text-foreground-400 text-xs mt-6">
          &copy; 2026 GTBuy Spreadsheet Hub. Independent information portal.
        </p>
      </div>
    </footer>
  );
}